import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import apiRequest from '../helpers/apiRequest';

import { fetchUserInfoThunk } from './index';

export const devLogin = (username, password, history) => (
    dispatch,
    getState
) => {
    apiRequest(
        endpoints.LOGIN,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data: { username: username, password: password } })
    )
        .then(payload => {
            sessionStorage.setItem('t', payload.data.token);
            sessionStorage.setItem('r', payload.data.refresh);
            dispatch(authUser(payload.data.token, payload.data.refresh));
        })
        .then(() => {
            dispatch(fetchUserInfoThunk());
            history.push('/');
        })
        .catch(error => {
            console.log(error);
            dispatch(
                devErrorMessage(
                    'Login is Incorrect or the server is being reset.'
                )
            );
        });
};

export const devErrorMessage = error => ({
    type: types.DEV_ERROR_LOGIN_MESSAGE,
    errorMessage: error
});

export const handleRequest = (
    payload,
    jwtToken,
    refreshId,
    userInfo = true
) => dispatch => {
    if (!payload.hasOwnProperty('errors')) {
        //Verify User Success
        dispatch(authUser(jwtToken, refreshId));
        if (userInfo) {
            dispatch(fetchUserInfoThunk());
        }
    } else {
        let error = payload.errors[0];
        if (error.status === 401) {
            //Verify User Error Status 401
            dispatch(refreshToken(jwtToken, refreshId));
        } else {
            //Verify User Error Other
            dispatch(unAuthUser());
        }
    }
};

export const refreshToken = (jwtToken, refreshId) => dispatch => {
    apiRequest(`${endpoints.REFRESH_TOKEN_PATH}/${refreshId}`, jwtToken)
        .then(payload => {
            //Refresh Token Success;
            dispatch(
                handleRequest(payload, payload.data.token, payload.data.refresh)
            );
        })
        .catch(() => {
            dispatch(unAuthUser());
        });
};

export const verifySessionId = id => dispatch => {
    apiRequest(`${endpoints.SESSION}/${id}`)
        .then(payload => {
            sessionStorage.setItem('t', payload.data.token);
            sessionStorage.setItem('r', payload.data.refresh);
            dispatch(
                handleRequest(payload, payload.data.token, payload.data.refresh)
            );
        })
        .catch(() => {
            dispatch(unAuthUser());
        });
};

export const verifyUser = (jwtToken, refreshId) => dispatch => {
    apiRequest(`${endpoints.VERIFY_TOKEN_PATH}`, jwtToken)
        .then(payload => {
            //Verify User
            dispatch(handleRequest(payload, jwtToken, refreshId));
        })
        .catch(error => {
            //Error verify user
            dispatch(authError(error));
            dispatch(unAuthUser());
        });
};

export const verifySessionUser = () => (dispatch, getState) => {
    apiRequest(`${endpoints.VERIFY_TOKEN_PATH}`, getState().auth.jwtToken)
        .then(payload => {
            //Verify User
            dispatch(
                handleRequest(
                    payload,
                    getState().auth.jwtToken,
                    getState().auth.refreshID,
                    false
                )
            );
        })
        .catch(error => {
            //Error verify user
            dispatch(authError(error));
            dispatch(unAuthUser());
        });
};

export const authUser = (jwtToken, refreshId) => {
    //authUser
    return {
        type: types.AUTH_USER,
        jwtToken,
        refreshId
    };
};

export const unAuthUserSettings = () => {
    return {
        type: types.UNAUTH_USER
    };
};

export const redirectUnAuthUser = () => {
    window.location.replace(endpoints.REDIRECT_AD_PORTAL);
};

export const unAuthUser = () => dispatch => {
    //unAuthUser
    sessionStorage.removeItem('r');
    sessionStorage.removeItem('t');
    dispatch(unAuthUserSettings);
    dispatch(redirectUnAuthUser);
};

export const unAuthDevUser = () => dispatch => {
    //unAuthUser
    sessionStorage.removeItem('r');
    sessionStorage.removeItem('t');
    dispatch(unAuthUserSettings);
    window.location.replace('/login');
};

export const authError = error => {
    return {
        type: types.AUTH_ERROR,
        userError: error
    };
};



// WEBPACK FOOTER //
// ./src/actions/auth.js